import { render, staticRenderFns } from "./Upper18Team.vue?vue&type=template&id=730a09fc&scoped=true"
import script from "./Upper18Team.vue?vue&type=script&lang=js"
export * from "./Upper18Team.vue?vue&type=script&lang=js"
import style0 from "./Upper18Team.vue?vue&type=style&index=0&id=730a09fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730a09fc",
  null
  
)

export default component.exports